// @ is an alias to /src
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import TabBar from '@/components/TabBar.vue';

export default {
  name: 'LayoutTemplate',
  components: {
    Footer,
    Aside,
    WayFindBar,
    ToolBar,
    TabBar,
  },
  data: {},
};
